import { Phone, Mail } from "lucide-react";
import { LOGO_URL, BUSINESS, SERVICES } from "@/data";

export const Footer = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="bg-ink border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center">
            <img src={LOGO_URL} alt={BUSINESS.name} className="h-16 w-16 object-contain" />
            <span className="ml-2 font-display font-extrabold text-white text-xl">CLEAR<span className="text-brand">CO</span></span>
          </div>
          <p className="mt-4 text-slate-400 max-w-sm leading-relaxed">
            {BUSINESS.tagline} Professional window, gutter & solar panel cleaning across Colorado's Front Range.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-slate-300 hover:text-brand transition-colors"><Phone size={16} strokeWidth={1.75} /> {BUSINESS.phone}</a>
            <a href={BUSINESS.emailHref} className="flex items-center gap-2 text-slate-300 hover:text-brand transition-colors"><Mail size={16} strokeWidth={1.75} /> {BUSINESS.email}</a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white">Services</h4>
          <ul className="mt-4 space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.key}>
                <button onClick={() => scrollTo("#services")} className="text-slate-400 hover:text-white transition-colors">{s.title}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white">Company</h4>
          <ul className="mt-4 space-y-2.5">
            {[["About", "#about"], ["Gallery", "#gallery"], ["Reviews", "#reviews"], ["Get a Quote", "#quote"], ["Contact", "#contact"]].map(([l, h]) => (
              <li key={h}><button onClick={() => scrollTo(h)} className="text-slate-400 hover:text-white transition-colors">{l}</button></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p>Serving {BUSINESS.areas.slice(0, 3).join(", ")} & surrounding areas.</p>
        </div>
      </div>
    </footer>
  );
};
